import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const items = [
    {
        title: 'Explore your options',
        info: 'In terms of different destinations, universities, courses & more..',
        numberOfCourses: '23 Courses',
        icon: 'icon-student-read',
        link: '#',
        button:'click here'
    },
    {
        title: 'Web Development',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '39 Courses',
        icon: 'icon-lab',
        link: '#',
        button:'AI University'
    },
    {
        title: 'Mathmatical Physics',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '45 Courses',
        icon: 'icon-compass',
        link: '#',
        button:'Book FREE'
    },
    {
        title: 'Number Theory',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '15 Courses',
        icon: 'icon-calculator',
        link: '#',
        button:'Courses'
    },
    {
        title: 'Data Sciences',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '25 Courses',
        icon: 'icon-microscopes',
        link: '#',
        button:'Student Dash'
    },
    {
        title: 'Web Development',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '18 Courses',
        icon: 'icon-calculator',
        link: '#',
        button:'Send Money'
    },
    {
        title: 'Art & Design',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '15 Courses',
        icon: 'icon-pen-tool',
        link: '#',
        button:'Send Cash'
    },
    {
        title: 'Nuclear Power',
        info: 'Lore Ipsum a simply dummy text of the printing.',
        numberOfCourses: '30 Courses',
        icon: 'icon-science',
        link: '#',
        button:'Money'
    }
];

const CategoryTwo = ( { wrapperClass, styleClass } ) => {
    return (
        <div className={ `row ${ wrapperClass || 'g-5 mt--25' }` }>
            { items.map( ( data , i ) => (
                // <ScrollAnimation 
                //     animateIn="fadeInUp"
                //     animateOut="fadeInOut"
                //     className={ `col-lg-3 col-md-6 col-sm-6 col-12 ${ styleClass ? styleClass : '' }` }
                //     animateOnce={ true }
                //     key={ i }
                // >
                <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                    <div className="service-card service-card-4">
                        <div className="inner">
                            <div className="icon">
                                <i className={ data.icon }></i>
                                <span className="subtitle">{ data.numberOfCourses }</span>
                            </div>
                            <div className="content">
                                <h6 className="title"><a href={ data.link }>{ data.title }</a></h6>
                                <p className="description">{ data.info }</p>
                                <button class="button-48" role="button"><span class="text">{data.button}</span></button>
                            </div>
                        </div>
                    </div>
                    </div>
                // </ScrollAnimation>
            ) ) }
        </div>
    )
}

export default CategoryTwo;